import { appointmentTypeKey } from '@/utils/appointmentFrequency';
import { capitalize } from '@/utils/constants';

const APPOINTMENT_TYPE_LABEL: Record<string, string> = {
  'ad hoc': 'Non-routine',
  combo: 'Combo',
  'eri tracking': 'ERI Tracking',
  'heart failure': 'Heart Failure',
  'in clinic': 'In Clinic',
  'physician request': 'Physician Request',
  routine: 'Routine'
};

const APPOINTMENT_STATUS_LABEL: Record<string, string> = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  cancelled: 'Cancelled',
  canceled: 'Cancelled',
  'no show': 'No Show',
  pending: 'Pending',
  missed: 'Missed'
};

/** Stored ad hoc appointments are shown as Non-routine. The API value stays ad hoc. */
export function appointmentTypeLabel(type?: string | null): string {
  if (!type?.trim()) return '';
  const key = appointmentTypeKey(type);
  return APPOINTMENT_TYPE_LABEL[key] ?? capitalize(type.replace(/[_-]+/g, ' '));
}

/** Normal capitalization. The API values stay lowercase. */
export function appointmentStatusLabel(status?: string | null): string {
  if (!status?.trim()) return '';
  const key = appointmentTypeKey(status);
  return APPOINTMENT_STATUS_LABEL[key] ?? capitalize(status.replace(/[_-]+/g, ' '));
}

const SCHEDULE_LIST_STATUSES = new Set([
  'scheduled',
  'completed',
  'cancelled',
  'no show',
  'pending',
  'missed'
]);

/** Status value for the schedules list. Omit anything the API does not accept, including All. */
export function appointmentListStatus(status?: string | null): string | undefined {
  const key = appointmentTypeKey(status);
  if (key === 'canceled') return 'cancelled';
  return SCHEDULE_LIST_STATUSES.has(key) ? key : undefined;
}

/** Create-appointment summary lines come back as "in clinic - 10/15/2026". */
export function appointmentSummaryLabel(summary?: string | null): string {
  const text = summary?.trim() ?? '';
  if (!text) return '';
  const splitAt = text.indexOf(' - ');
  const prefix = splitAt === -1 ? text : text.slice(0, splitAt);
  const label = APPOINTMENT_TYPE_LABEL[appointmentTypeKey(prefix)];
  if (!label) return text;
  return splitAt === -1 ? label : `${label}${text.slice(splitAt)}`;
}
